export const ItemTypes = {
  DNDBOX: 'dndbox',
  DragBox: 'dragBox',
  ContentBox: 'contentBox',
};

export interface DragItem {
  type: string;
  id: string;
  top: number | string;
  left: number | string;
  width: number;
  height: number;
  el: HTMLElement;
  text: string;
}
export interface ContentBoxItem {
  type: 'text' | 'image' | 'audio';
  id: string;
  top: number | string;
  left: number | string;
  width: number;
  height: number;
  el: HTMLElement;
  src: string;
}
